var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAlarmRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    "aria-labelledby": titleId,
    width: "90px",
    height: "90px",
    viewBox: "0 0 90 90",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "alarmTitle"
  }, "Alarm") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "alarmTitle"
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF2EF",
    cx: 45,
    cy: 45,
    r: 45
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5,26 C56.2695526,26 65,34.7304474 65,45.5 C65,56.2695526 56.2695526,65 45.5,65 C34.7304474,65 26,56.2695526 26,45.5 C26,34.7304474 34.7304474,26 45.5,26 Z M45.5,28 C35.8350169,28 28,35.8350169 28,45.5 C28,55.1649831 35.8350169,63 45.5,63 C55.1649831,63 63,55.1649831 63,45.5 C63,35.8350169 55.1649831,28 45.5,28 Z",
    fill: "#FC5C42",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45,35 C45.5522847,35 46,35.4477153 46,36 L46,50 C46,50.5522847 45.5522847,51 45,51 C44.4477153,51 44,50.5522847 44,50 L44,36 C44,35.4477153 44.4477153,35 45,35 Z",
    fill: "#FC5C42"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FC5C42",
    x: 44,
    y: 53,
    width: 2,
    height: 2,
    rx: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlarmRed);
export default __webpack_public_path__ + "static/media/icon-alarm-red.33d3735c247e9da05a17e12a445c683d.svg";
export { ForwardRef as ReactComponent };